import AuthService from "../../../services/AuthService";
import SubscriptionService from "../../../services/Subscription.service";
import { SUBSCRIPTION_STATUS } from '@/const/subscription';
import moment from 'moment';

export default {
    data() {
        return {
            publishable_key: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
            price_table_id: process.env.VUE_APP_STRIPE_PRICE_TABLE_ID,
            is_subscription: false,
            is_trialing: false,
            subscription: null,
            is_creating_stripe_customer_session: true,
            stripe_customer_session_secret: null,
        }
    },
    computed: {
        user_email() {
            return AuthService.getUserCurrentLogin().email;
        },
        organizaion_id() {
            return AuthService.getOrganizationId();
        },
        subscription_status() {
            if (this.subscription.status == SUBSCRIPTION_STATUS.ACTIVE) {
                return this.$t('subscription.active');
            } else if (this.subscription.status == SUBSCRIPTION_STATUS.TRIALING) {
                return this.$t('subscription.trialing');
            } else {
                return this.$t('subscription.inactive');
            }
        },
        statusClass () {
            if (this.subscription.status == SUBSCRIPTION_STATUS.ACTIVE || this.subscription.status == SUBSCRIPTION_STATUS.TRIALING) {
                return 'badge badge-success';
            } else {
                return 'badge badge-danger';
            }
        },
        usage_ai_model_count() {
            return `${this.subscription.usage_ai_model_count} / ${this.subscription.ai_model_count}`;
        },
        usage_user_count() {
            return `${this.subscription.usage_user_count} / ${this.subscription.user_count}`;
        },
        usage_train_count() {
            return `${this.subscription.usage_train_count} / ${this.subscription.train_count}`;
        },
        usage_inference_count() {
            return `${this.subscription.usage_inference_count} / ${this.subscription.inference_count}`;
        },
        usage_ai_model_count_percent() {
            return parseFloat((this.subscription.usage_ai_model_count / this.subscription.ai_model_count) * 100).toFixed(1);
        },
        usage_user_count_percent() {
            return parseFloat((this.subscription.usage_user_count / this.subscription.user_count) * 100).toFixed(1);
        },
        usage_train_count_percent() {
            return parseFloat((this.subscription.usage_train_count / this.subscription.train_count) * 100).toFixed(1);
        },
        usage_inference_count_percent() {
            return parseFloat((this.subscription.usage_inference_count / this.subscription.inference_count) * 100).toFixed(1);
        }
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
    },
    mounted() {
        SubscriptionService.getSubscription().then(() => {
            // get store data
            this.subscription = this.$store.getters.subscription;
            if (this.subscription) {
                this.is_subscription = this.subscription.status == SUBSCRIPTION_STATUS.ACTIVE;
                this.is_trialing = this.subscription.status == SUBSCRIPTION_STATUS.TRIALING;
            }
        });
        // if stripe customer id is set, create stripe customer session
        SubscriptionService.createStripeCustomerSession().then((data) => {
            this.stripe_customer_session_secret = data;
            this.is_creating_stripe_customer_session = false;
        }).catch(() => {
            this.stripe_customer_session_secret = null;
            this.is_creating_stripe_customer_session = false;
        });
    },
    methods: {
        formatDate(value) {
            return moment(value).utcOffset("+09:00").format('YYYY-MM-DD');
        },
        showSubscritpionCustomerPage() {
            // show subscription customer page in new tab
            window.open(process.env.VUE_APP_STRIPE_CUSTOMER_PORTAL_URL, '_blank');
        },
        progress_bar_class(percent) {
            if (percent <= 50) {
                return 'progress-bar bg-info';
            } else if (percent <= 75) {
                return 'progress-bar bg-warning';
            } else {
                return 'progress-bar bg-danger';
            }
        }
    }
}
